import axios from 'axios'
import qs from 'qs'
var args = {};
// 获取地址栏参数
if (window.location.href.split("?")[1]) {
    var query = window.location.href.split("?")[1];
    var pairs = query.split("&");
    for (var i = 0; i < pairs.length; i++) {
        var pos = pairs[i].indexOf("=");
        if (pos == -1) continue;
        var name = pairs[i].substring(0, pos);
        var value = pairs[i].substring(pos + 1);
        value = decodeURIComponent(value);
        args[name] = value;
    }
}

console.log(args, '地址栏参数')
export default {
    wxShowMenu: function (passCode, fundCode) {
        console.log('passCode', passCode);
        let baseURL = window.location.protocol + '//' + window.location.host;
        let url = '/wc/shareConfig'
        // var baseURL = 'http://10.201.226.140:9400/'
        let data = window.location.href.split('#')[0]
        var params = {
            url: data,
            pageType: passCode || '1',
            params: {
                fundCode: fundCode || ''
            },
            custom: args.custom || ''
        }
        params.params = JSON.stringify(params.params)
        axios({
            method: 'post',
            baseURL: baseURL,
            url: url,
            data: qs.stringify(params),
            emulateJSON: true,
            timeout: 50000,
        }).then(res => {
            console.log(res);
            var getMsg = res.data.body.data;
            wx.config({
                debug: false, //生产环境需要关闭debug模式
                appId: getMsg.appId, //appId通过微信服务号后台查看
                timestamp: getMsg.timestamp, //生成签名的时间戳
                nonceStr: getMsg.nonceStr, //生成签名的随机字符串
                signature: getMsg.signature, //签名
                jsApiList: [ //需要调用的JS接口列表
                    'onMenuShareTimeline', //分享给好友
                    'onMenuShareAppMessage', //分享到朋友圈
                    'showMenuItems',
                    'hideMenuItems'
                ]
            });
            wx.checkJsApi({
                jsApiList: ["showMenuItems"],
                success: function (res) {
                    wx.showMenuItems({
                        menuList: [
                            'menuItem:share:appMessage', //发送给朋友
                            'menuItem:share:timeline' //分享到朋友圈
                        ]
                    });
                }
            });
            //分享到朋友圈
            wx.onMenuShareTimeline({
                title: getMsg.title, // 分享标题
                desc: getMsg.desc, //分享描述
                link: getMsg.link, // 分享链接，一定要获取当前页面的URL
                imgUrl: getMsg.imgUrl, // 分享图标
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
                title: getMsg.title, // 分享标题
                desc: getMsg.desc, // 分享描述
                link: getMsg.link, // 分享链接
                imgUrl: getMsg.imgUrl, // 分享图标
            });
            // 钉钉环境自定义分享
            if (navigator.userAgent.indexOf('DingTalk') !== -1){
                dd.ready(function() {
                    dd.biz.navigation.setRight({
                        show: true, //控制按钮显示， true 显示， false 隐藏， 默认true
                        control: true, //是否控制点击事件，true 控制，false 不控制， 默认false
                        text: '...', //控制显示文本，空字符串表示显示默认文本
                        onSuccess: function(result) {
                            //如果control为true，则onSuccess将在发生按钮点击事件被回调
                            dd.biz.util.share({
                                type: 0, //分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
                                url: getMsg.link, // 分享链接
                                title: getMsg.title, // 分享标题
                                content: getMsg.desc, //分享描述
                                image: getMsg.imgUrl, // 分享图标
                                onSuccess: function() {
                                    console.log('钉钉环境分享成功')
                                },
                                onFail: function(err) {
                                    console.log('钉钉环境分享失败',err)
                                }
                            })
                        },
                        onFail: function(err) {}
                    });
                })
            }
        })
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/wx.jsapi.js